<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section
    [class]="'fudis-mt-md'"
    [width]="'lg'"
    [level]="2"
    [titleVariant]="'lg'"
    [title]="stepNumber + '. ' + t('GRADUATION_WIZARD.STEP_2')">
    <fudis-section-content>
      @if (surveyEnabled) {
        <fudis-body-text [class]="'fudis-mt-md'">{{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.SURVEY_INFO") }}</fudis-body-text>
        <fudis-body-text [class]="'fudis-mt-md'">{{ t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.SURVEY_INFO_NO_ANSWER") }}</fudis-body-text>
        <fudis-body-text [class]="'fudis-mt-md'">{{
          t("GRADUATION.APPLY_FOR_GRADUATION_MODAL.SURVEY_INFO_ALREADY_ANSWERED")
        }}</fudis-body-text>
        <fudis-notification [class]="'fudis-mt-md'" [variant]="'info'">
          <fudis-body-text>{{ t("GRADUATION_WIZARD.STEP_2_SURVEY_REDIRECT_INFO") }}</fudis-body-text>
        </fudis-notification>
      } @else {
        <fudis-body-text [class]="'fudis-mt-md'">{{ t("GRADUATION_WIZARD.STEP_2_OPT_IN_TEXT_1") }}</fudis-body-text>
        <fudis-body-text [class]="'fudis-mt-md'">{{ t("GRADUATION_WIZARD.STEP_2_OPT_IN_TEXT_2") }}</fudis-body-text>
        <fudis-body-text [class]="'fudis-mt-md'">
          <a fudisLink [href]="localizedSurveyUrl" [title]="t('GRADUATION_WIZARD.STEP_2_SURVEY_LINK')" [external]="true" [size]="'md'"></a>
        </fudis-body-text>
      }
      <sis-wizard-step-buttons
        [backButtonTitle]="t('GRADUATION_WIZARD.BACK_BUTTON')"
        [forwardButtonTitle]="t('GRADUATION_WIZARD.CONTINUE_BUTTON')"
        (back)="back.emit()"
        (forward)="onForwardClick()">
      </sis-wizard-step-buttons>
    </fudis-section-content>
  </fudis-section>
</ng-container>
